import React from 'react';

function AboutUs() {
  return (
    <div id="aboutUs" className="col-12 text-center mt-2">
      <br />
      <div className="row text-background text-center">
        <div className="col-12 mb-2 wow slideInUp">
          <div className="text-white mukta" style={{ display: 'inline-block' }}>
            <h1>
              <i className="fas fa-chevron-right"></i>
              <i className="fas fa-chevron-right"></i>
              &nbsp;Definición&nbsp;
              <i className="fas fa-chevron-left"></i>
              <i className="fas fa-chevron-left"></i>
            </h1>
          </div>
          <br />
        </div>
        <div className="col-md-2"></div>
        <div className="col-md-3 col-12 wow slideInUp">
          <div className="container container-fluid">
            <h2 className="font-weight-bold text-white">Ineffable</h2>
            <p className="card-text text-white bg-ineffable">
              No puede ser expresado o descrito en palabras debido a su genialidad.
            </p>
          </div>
        </div>
        <div className="col-md-2 col-12 text-white align-self-center wow slideInUp">
          <i className="fas fa-plus fa-3x mt-2 mb-2"></i>
        </div>
        <div className="col-md-3 col-12 wow slideInUp">
          <div className="container container-fluid">
            <h2 className="font-weight-bold text-white">Inventions</h2>
            <p className="card-text text-white bg-ineffable">
              Algo único que nunca había sido construido o utilizado.
            </p>
          </div>
        </div>
        <div className="col-md-2"></div>

        <div className="col-12 mt-5 mb-2">
          <div className="text-white mukta wow slideInUp" style={{ display: 'inline-block' }}>
            <h1>
              <i className="fas fa-chevron-right"></i>
              <i className="fas fa-chevron-right"></i>
              &nbsp;Significado&nbsp;
              <i className="fas fa-chevron-left"></i>
              <i className="fas fa-chevron-left"></i>
            </h1>
          </div>
        </div>
        <div className="col-md-2"></div>
        <div className="col-md-8 wow slideInUp col-12 text-white bg-ineffable">
          <div className="container container-fluid">
            <h3>
              Somos un emprendimiento innovador que imagina, diseña e implementa soluciones únicas de software que
              sobresalen por su creatividad y sus beneficios a la sociedad.
            </h3>
          </div>
        </div>
        <div className="col-md-2"></div>
      </div>
    </div>
  );
}

export default AboutUs;
